import { AuthStatus } from "@/types/procedure";


export const authStatusMapping: Record<string, AuthStatus> = {
  NEEDS_INFO: "Needs Info",
  PENDING: "Pending",
  NOT_REQUIRED: "Not Required",
  OBTAINED: "Obtained",
  CLOSED: "Closed",
};
